import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button';
import Layout from '../../core/Layout';
import { getTrade } from '../apiUser';
import { isAuthenticated } from '../../auth';
import { acceptTrade, createOrder, saveMessages, getProduct, getUserInfo, newMessageFalse } from '../apiUser';
import { API } from '../../config';
import { sendNotification } from '../../core/sendNotification';
import ChatArea from './ChatArea';
import socket from './socket';
import { RefreshIcon } from '@heroicons/react/solid';
import EditDropdown from './EditDropdown';
import AcceptCancelTrade from './AcceptCancelTrade';
import TradeAcceptedBanner from './TradeAcceptedBanner';
import TradeCanceledBanner from './TradeCanceledBanner';
import SuccessModal from '../../core/SuccessModal';

const Trade = () => {
    const { urlTradeId } = useParams();

    const [isReciever, setIsReciever] = useState(false);
    const [trade, setTrade] = useState({});
    const [tradeStatus, setTradeStatus] = useState('');

    const [showAcceptTrade, setShowAcceptTrade] = useState(false)
    const handleShowAcceptTrade = () => setShowAcceptTrade(true);
    const handleCloseAcceptTrade = () => setShowAcceptTrade(false);


    const [showDeclineTrade, setShowDeclineTrade] = useState(false)
    const handleShowDeclineTrade = () => setShowDeclineTrade(true);
    const handleCloseDeclineTrade = () => setShowDeclineTrade(false);

    const [message, setMessage] = useState('');
    const [messages, setMessages] = useState([]);
    const [sendTo, setSendTo] = useState('');

    const [successOpen, setSuccessOpen] = useState(false);
    const handleSuccessOpen = () => setSuccessOpen(true);
    const handleSuccessClose = () => setSuccessOpen(false);
    const [successText, setSuccessText] = useState({
        title: '',
        description: '',
        link: '',
    });



    const [recieverProduct, setRecieverProduct] = useState({});
    const [senderProducts, setSenderProducts] = useState([]);
    const {user: {_id, name }, token } = isAuthenticated();


    const getProducts = trade => {
        const { recieverItem, senderItems } = trade; //gets IDs
        console.log(trade);
        getProduct(recieverItem).then(data => setRecieverProduct(data));
        senderItems.forEach(senderItem => {
            getProduct(senderItem).then(data => {
                setSenderProducts(senderProducts => senderProducts.concat(data))
            });
        });
    };

    useEffect(() => {
        getTrade(urlTradeId, _id, token).then(async data => {
            const tradeData = await data[0];

            setTradeStatus(tradeData.status);

            await setTrade(tradeData);
            await getProducts(tradeData);
            await setMessages(tradeData.messages);
            await tradeData.reciever === _id ? setIsReciever(true) : setIsReciever(false);
            const tradeId = await tradeData._id;
            const userId = await _id;
            //for some reason isReciever doesnt work below 

            socket.auth = await { tradeId, userId };
            await socket.connect();

            socket.on('private message', ({ content, from, to }) => {
                console.log('INCOMMING: '+content);
                console.log('cmp: '+ from +' === ' +_id);
                setMessages(messages => [...messages, content])
            });

            newMessageFalse(tradeData._id, token, tradeData.reciever === _id).then(result => {
                if (result.error) {
                    console.log('error in updating new message: ' + data.error);
                }
            });
        });



        return function cleanup() {
            socket.off('connect');
            socket.off('disconnect');
            socket.off('private message');
        };

    },[]);

    //sockets functions
    const handleChange = event => {
        const value = event.target.value;
        setMessage(value);
    };

    const messageSubmit = event => {

        event.preventDefault();
        if (message === '') {
            return
        }
        //const findId = trade.reciever === _id ? trade.reciever : trade.sender;
        const findId = trade.reciever === _id ? trade.sender : trade.reciever;
        event.preventDefault();
        const content = {message: message, userName: name};
        socket.emit('private message', {
            content,
            to: trade._id
        });

        const chatBoxMessage = { message: message, userName: name };
        //save message to db
        saveMessages(chatBoxMessage, _id, trade._id, token).then(data => console.log(data));

        setMessages(messages => [...messages, chatBoxMessage])
        setMessage('');

        //send notification
        sendNotification('message', trade._id,`New Message from ${name}`, 'Click to view message',``,`/trade/${trade._id}`,_id, findId, isReciever);
    };


    const MessageBox = () => (
        <div className="flex items-start space-x-4">
            <div className="flex-shrink-0">
                { isReciever ?
                    <img
                        className="inline-block h-10 w-10 rounded-full"
                        src={trade.recieverProfilePicture}
                        alt=""
                    />
                    :
                    <img
                        className="inline-block h-10 w-10 rounded-full"
                        src={trade.senderProfilePicture}
                        alt=""
                    />
                }
            </div>
            <div className="min-w-0 flex-1">
                <form className="relative" onSubmit={messageSubmit} autocomplete='off'>
                    <div className="border border-gray-300 rounded-lg shadow-sm overflow-hidden focus-within:border-indigo-500 focus-within:ring-1 focus-within:ring-indigo-500">
                        <label htmlFor="message" className="sr-only">
                            Send Message...
                        </label>
                        <input
                            autoFocus="autoFocus" //fixes the focusing problem (see stack overflow for a cleaner soluton)
                            type='text'
                            rows={1}
                            name="message"
                            id="message"
                            className="block w-full py-3 border-0 resize-none focus:ring-0 sm:text-sm"
                            placeholder="Send Message..."
                            defaultValue={''}
                            onChange={handleChange}
                            value={message}
                        />

                        {/* Spacer element to match the height of the toolbar */}
                        <div className="py-2" aria-hidden="true">
                            {/* Matches height of button in toolbar (1px border + 36px content height) */}
                            <div className="py-px">
                                <div className="h-9" />
                            </div>
                        </div>
                    </div>

                    <div className="absolute bottom-0 inset-x-0 pl-3 pr-2 py-2 flex justify-between">
                        <div className="flex items-center space-x-5">
                            <div className="flex items-center">
                                <button
                                    type="submit"
                                    className="-m-2.5 w-10 h-10 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-500"
                                >
                                </button>
                            </div>
                            <div className="flex items-center">
                            </div>
                        </div>
                        <div className="flex-shrink-0">
                            <button
                                type="submit"
                                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            >
                                Send
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );


    const SenderMoneyOffer = () => (
        <>
        { (trade.senderMoneyOffer !== 0.00) || (trade.senderMoneyOffer !== 0) && 
        <div className="lg:flex rounded mt-3 text-center ">
                <dt className="order-1 text-sm leading-6 font-medium text-gray-500 text-xs ">Additional Money Offer: </dt>
            <dd className="order-2 text-md font-extrabold text-green-600 ml-1">+${trade.senderMoneyOffer}</dd>
            </div> 
        }
        </>
    );

    const RecieverMoneyOffer = () => (
        <>
        { (trade.recieverMoneyOffer !== 0.00) || (trade.recieverMoneyOffer !== 0) && 
        <div className="lg:flex rounded mt-3 text-center ">
                <dt className="order-1 text-sm leading-6 font-medium text-gray-500 text-xs">Additional Money Offer: </dt>
            <dd className="order-2 text-md font-extrabold text-green-600 ml-1">+${trade.recieverMoneyOffer}</dd>
            </div> 
        }
        </>
    );

    const showItems = () => {
        const imgStyle = {
            width: '300px',
            height: 'auto',
            maxHeight: '100vh'
        };

        if (isReciever) {
            return (
                <div className='h-[28rem]'>
                    <h2 className='font-extrabold text-black'> Your Item </h2>
                    <div className='border border-grey-300 mb-2 rounded-lg'>
                        <div className='m-1'>
                            <img 
                                src={`${API}/static/product_photos/${recieverProduct.primary_photo}`} 
                                style={imgStyle}
                                alt={recieverProduct.name}
                                className='object-cover rounded-lg mx-auto'
                            />
                            <RecieverMoneyOffer/>
                        </div>
                    </div>
                    <h2 className='flex flex-shrink text-md'><h2 className='font-extrabold text-black'> {trade.senderName}'s </h2>&nbsp;items</h2>
                    <div className='border border-grey-300 rounded-lg'>
                        { senderProducts.length === 1 ?
                            <>
                                <img 
                                    src={`${API}/static/product_photos/${senderProducts[0].primary_photo}`} 
                                    style={imgStyle}
                                    className='object-over rounded-lg mx-auto'
                                    alt={senderProducts[0].name}
                                />
                                <SenderMoneyOffer/>
                            </>
                            :
                            <>
                            <div className='grid lg:grid-cols-2 md:grid-cols-3 sm:grid-cols-2 gap-1 overflow-y-scroll' >
                                {senderProducts.map((senderProduct, i) => (
                                    <img 
                                        src={`${API}/static/product_photos/${senderProduct.primary_photo}`} 
                                        style={imgStyle}
                                        className='object-over rounded-lg mx-auto'
                                        alt={senderProduct.name}
                                    />
                                ))}
                            </div>
                            <SenderMoneyOffer/>
                            </>
                        }
                    </div>

                </div>

            );
        }
        else {
            return (
                <div className='h-[32rem]'>
                    <div className='m-1'>
                        <h2 className='font-extrabold text-black'> Your Item(s) </h2>
                        <div className='border border-grey-300 mb-1 rounded-lg'>
                            <div className='p-1'>
                                { senderProducts.length === 1 ?
                                    <>
                                        <img 
                                            src={`${API}/static/product_photos/${senderProducts[0].primary_photo}`} 
                                            style={imgStyle}
                                            className='object-over rounded-lg mx-auto'
                                            alt={senderProducts[0].name}
                                        />
                                        <SenderMoneyOffer/>
                                    </>
                                    :
                                    <>
                                        <div className='grid lg:grid-cols-2 md:grid-cols-3 sm:grid-cols-2 gap-1 overflow-y-scroll' >
                                            {senderProducts.map((senderProduct, i) => (
                                                <img 
                                                    src={`${API}/static/product_photos/${senderProduct.primary_photo}`} 
                                                    style={imgStyle}
                                                    className='object-over rounded-lg mx-auto'
                                                    alt={senderProduct.name}
                                                />
                                            ))}
                                        </div>
                                        <SenderMoneyOffer/>
                                    </>
                                }
                            </div>
                        </div>

                        <h2 className='flex'><h2 className='font-extrabold text-black'> {trade.recieverName}'s </h2>&nbsp;item</h2>
                        <div className='border border-grey-300 rounded-lg'>
                            <div className='p-1'>
                                <img 
                                    src={`${API}/static/product_photos/${recieverProduct.primary_photo}`} 
                                    style={imgStyle}
                                    alt={recieverProduct.name}
                                    className='object-cover rounded-lg mx-auto'
                                />
                                <RecieverMoneyOffer/>
                            </div>
                        </div>

                    </div>

                </div>
            );

        }
    };


    const MainSection = () => (
        <div id='chat-area'>

            <div className='grid grid-cols-4 gap-3'>
                <div className='col-span-1'>
                    {showItems()} 
                </div>
                <div className='col-span-3'>
                    <ChatArea messages={messages} trade={trade}/>
                    <MessageBox/>
                </div>
            </div>

        </div>

    );

    const Header = () => ( //TODO; put in separate file later
        <div className="bg-indigo-50">
            <div className="max-w-7xl mx-auto py-3 px-4 sm:px-4 lg:py-6 lg:px-8 lg:flex lg:items-center lg:justify-between">
                <h2 className="text-lg font-extrabold tracking-tight text-gray-900 md:text-md">
                    {isReciever ? 
                        <span className="block text-2xl sm:text-xl">Trade with {trade.senderName}</span>
                        :
                        <span className="block text-2xl sm:text-xl">Trade with {trade.recieverName}</span>
                    }
                    <span className='block text-indigo-600 flex text-sm'>{trade.recieverItemName} <RefreshIcon className='h-5 w-5 mx-2'/>
                        {trade.senderItemsNames && trade.senderItemsNames.map((senderItemName,i) => (
                            <div key={i}>
                                {senderItemName} 
                                {trade.senderItemsNames.length > 1 && i+1 !== trade.senderItemsNames.length 
                                    ? <> +&nbsp;</> 
                                    : <> </>
                                }  
                            </div>
                        ))}
                    </span>


                </h2>
                <div className="mt-8 lg:flex lg:mt-0 lg:flex-shrink-0">

                    <AcceptCancelTrade 
                        trade={trade} 
                        setTradeStatus={setTradeStatus} 
                        sendNotification={sendNotification}
                        setSuccessText={setSuccessText}
                        handleSuccessOpen={handleSuccessOpen}
                    />
                </div>
            </div>
        </div>
    );

    const BannerRenderConditions = () => {
        if (tradeStatus === 'pending') {
            return( <Header/> ); 
        }
        else if (tradeStatus === 'accepted') {
            return ( <TradeAcceptedBanner trade={trade} isReciever={isReciever}/> )
        }
        else if (tradeStatus === 'canceled') {
            return (<TradeCanceledBanner trade={trade} isReciever={isReciever}/>);
        }
        else { //just in case lol
            return ( <Header/> );
        }
    };

    return (
        <Layout>
            <BannerRenderConditions/>
            <SuccessModal
                title={successText.title}
                description={successText.description}
                open={successOpen}
                handleClose={handleSuccessClose}
                link={successText.link}
            />
            <div className='lg:px-40 md:px-20 sm:px-4 mt-3'>
                <MainSection/>
            </div>
        </Layout>
    );
};

export default Trade;
